import appConfig from 'src/utils/appConfig';
import router from 'src/router';
import { getQueryString } from 'src/router/queryString';
import { getDefaultLearningLanguage } from 'src/utils/localeMapping';


const flowLinksService = {
  getFlowLink: function(requestedFlowName, learningLanguage = appConfig.getLearningLanguage()) {
    return `${router.getRoot()}/${learningLanguage}/${requestedFlowName}${getQueryString()}`;
  },
  getLocalizedFlowLink: function(newLocale, requestedFlowName) {
    const { locale } = appConfig.getMyConfig();
    const defaultLearningLanguage = getDefaultLearningLanguage(newLocale);
    const flowLink = this.getFlowLink(requestedFlowName, defaultLearningLanguage).replace(locale, newLocale);
    return `${flowLink}`;
  }
};

export default flowLinksService;
